import React from "react";
import "./PST_Academy.css";

const PST_Academy = () => {
  return (
    <section className="PST_Academy">
      <div className="container-fluid p-0">
        <div className="row">
          <div className="col-lg-6 p-0">
            <div className="video_holder">
              <video autoPlay muted loop playsInline className="bg_video">
                <source src="/assets/videos/pst-video.mp4" type="video/mp4" />
              </video>
              <div class="video_content">
                <p>UPSKILL RATE</p>
                <h5>99%</h5>
                <p>WITH PST ACADEMY</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6 p-0">
            <div className="right_content_div">
              <div>
                <h5>PST IT SOLUTIONS</h5>
                <h5>Learning Experience</h5>

                <div className="content_div_holder">
                  <div className="content_div">
                    <div className="content_icon_holder">
                      <img
                        src="/assets/images/home/pst-academy/icon-1.png"
                        alt="icon"
                        className="content_icon"
                      />
                    </div>

                    <div className="content_text_div">
                      <p className="bold_text">
                        Structured and Effective Learning Path
                      </p>
                      <p className="normal_text">
                        A step-by-step roadmap, designed by MAANG engineers,
                        that cuts the noise and keeps you focused.
                      </p>
                    </div>
                  </div>

                  <div className="content_div">
                    <div className="content_icon_holder">
                      <img
                        src="/assets/images/home/pst-academy/icon-2.png"
                        alt="icon"
                        className="content_icon"
                      />
                    </div>

                    <div className="content_text_div">
                      <p className="bold_text">
                        Live Classes (Assignments + Projects)
                      </p>
                      <p className="normal_text">
                        Learn from industry experts, practice with guided
                        assignments, and build projects that showcase real
                        skills.
                      </p>
                    </div>
                  </div>

                  <div className="content_div">
                    <div className="content_icon_holder">
                      <img
                        src="/assets/images/home/pst-academy/icon-3.png"
                        alt="icon"
                        className="content_icon"
                      />
                    </div>

                    <div className="content_text_div">
                      <p className="bold_text">1:1 Mentorship</p>
                      <p className="normal_text">
                        Get personalized guidance from engineers who’ve already
                        cracked the path you’re aiming for.
                      </p>
                    </div>
                  </div>

                  <div className="content_div">
                    <div className="content_icon_holder">
                      <img
                        src="/assets/images/home/pst-academy/icon-4.png"
                        alt="icon"
                        className="content_icon"
                      />
                    </div>

                    <div className="content_text_div">
                      <p className="bold_text">Placement Support</p>
                      <p className="normal_text">
                        From resume building to mock interviews, we stay with
                        you until you land your dream role.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PST_Academy;
